import { render, staticRenderFns } from "./ThemeSettingsDirectTop2.vue?vue&type=template&id=394dc9b4&scoped=true"
import script from "./ThemeSettingsDirectTop2.vue?vue&type=script&lang=js"
export * from "./ThemeSettingsDirectTop2.vue?vue&type=script&lang=js"
import style0 from "./ThemeSettingsDirectTop2.vue?vue&type=style&index=0&id=394dc9b4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "394dc9b4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('394dc9b4')) {
      api.createRecord('394dc9b4', component.options)
    } else {
      api.reload('394dc9b4', component.options)
    }
    module.hot.accept("./ThemeSettingsDirectTop2.vue?vue&type=template&id=394dc9b4&scoped=true", function () {
      api.rerender('394dc9b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings/projects/themes/ThemeSettingsDirectTop2.vue"
export default component.exports